import React, { useState, useEffect } from 'react';
import SvgEditor from './components/SvgEditor';
import Login from './components/Login';
import authConfig from './authConfig';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  // Check for existing session on mount
  useEffect(() => {
    const savedSession = localStorage.getItem(authConfig.sessionKey);
    if (savedSession) {
      try {
        const session = JSON.parse(savedSession);
        // Check if session is expired
        if (session.expiresAt && Date.now() > session.expiresAt) {
          localStorage.removeItem(authConfig.sessionKey);
        } else {
          setIsAuthenticated(true);
          setCurrentUser(session.username);
        }
      } catch (err) {
        localStorage.removeItem(authConfig.sessionKey);
      }
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (session) => {
    setIsAuthenticated(true);
    setCurrentUser(session.username);
  };

  const handleLogout = () => {
    localStorage.removeItem(authConfig.sessionKey);
    setIsAuthenticated(false);
    setCurrentUser(null);
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <div className="user-badge" onClick={handleLogout} title="Click to logout">
        <span className="user-icon">👤</span>
        <span className="user-name">{currentUser}</span>
        <span className="logout-text">Logout</span>
      </div>
      <SvgEditor />
    </div>
  );
}

export default App;
